import { useNavigate } from "react-router-dom";
import { IndofastLogo } from "./IndofastLogo";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      background: "#F8FAFC",
      gap: 24,
      padding: 32,
      textAlign: "center",
    }}>
      <IndofastLogo height={40} variant="dark" />

      <div style={{ marginTop: 8 }}>
        <div style={{ fontSize: 80, fontWeight: 800, color: "#1A6FA8", lineHeight: 1 }}>
          404
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: "#111827", marginTop: 12 }}>
          Page not found
        </div>
        <div style={{ fontSize: 14, color: "#6B7280", marginTop: 8, maxWidth: 340, lineHeight: 1.6 }}>
          The URL you entered doesn't exist. Please check the address or return to the Support CRM.
        </div>
      </div>

      <button
        onClick={() => navigate("/support", { replace: true })}
        style={{
          marginTop: 8,
          padding: "10px 28px",
          background: "#1A6FA8",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          cursor: "pointer",
        }}
        onMouseEnter={e => e.currentTarget.style.background = "#155d8f"}
        onMouseLeave={e => e.currentTarget.style.background = "#1A6FA8"}
      >
        Go to Support CRM
      </button>
    </div>
  );
}

export default NotFoundPage;
